/*
 *
 * ApmSwitch
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 29-Jan-2025
 */

import ApmSwitch from './ApmSwitch'

export default ApmSwitch
